import { versionsDescending, plansAscending } from 'services/sorting';
import {
  GET_SERVICES_REQUESTED,
  GET_SERVICES_SUCCESS,
  GET_SERVICES_FAILURE,
  GET_SERVICESUBTYPES_REQUESTED,
  GET_SERVICESUBTYPES_SUCCESS,
  GET_SERVICESUBTYPES_FAILURE,
  GET_PROVIDERS_REQUESTED,
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS_FAILURE,
  GET_VERSIONS_REQUESTED,
  GET_VERSIONS_SUCCESS,
  GET_VERSIONS_FAILURE,
  GET_REGIONS_REQUESTED,
  GET_REGIONS_FAILURE,
  GET_REGIONS_SUCCESS,
  GET_PLANS_REQUESTED,
  GET_PLANS_SUCCESS,
  GET_PLANS_FAILURE,
  GET_FLAVORS_REQUESTED,
  GET_FLAVORS_SUCCESS,
  GET_FLAVORS_FAILURE,
  GET_ADDONS_REQUESTED,
  GET_ADDONS_SUCCESS,
  GET_ADDONS_FAILURE,
  GET_CATALOG_CONFIG_REQUEST,
  GET_CATALOG_CONFIG_FAILURE,
  GET_CATALOG_CONFIG_SUCCESS,
} from '../actions';

export const initialState = {
  servicesCatalog: {
    services: [],
    isLoading: false,
    error: false,
  },
  serviceSubtypesCatalog: {
    serviceSubtypes: [],
    isLoading: false,
    error: false,
  },
  providersCatalog: {
    providers: [],
    isLoading: false,
    error: false,
  },
  versionsCatalog: {
    versions: [],
    isLoading: false,
    error: false,
  },
  regionsCatalog: {
    regions: [],
    isLoading: false,
    error: false,
  },
  plansCatalog: {
    plans: [],
    isLoading: false,
    error: false,
  },
  flavorsCatalog: {
    flavors: [],
    isLoading: false,
    error: false,
  },
  addonsCatalog: {
    addons: [],
    isLoading: false,
    error: false,
  },
  configurationsCatalog: {
    configurations: [],
    isLoading: false,
    error: false,
  },
};

// function getThingByName(things) {
//   return things.reduce((services, service) => [...services, service.name], []);
// }

export default function catalogReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SERVICES_REQUESTED:
      return {
        ...state,
        servicesCatalog: {
          ...state.servicesCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        servicesCatalog: {
          services: action.payload,
          isLoading: false,
          error: false,
        },
      };

    case GET_SERVICES_FAILURE:
      return {
        ...state,
        servicesCatalog: {
          ...state.servicesCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_SERVICESUBTYPES_REQUESTED:
      return {
        ...state,
        serviceSubtypesCatalog: {
          ...state.serviceSubtypesCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_SERVICESUBTYPES_SUCCESS:
      return {
        ...state,
        serviceSubtypesCatalog: {
          serviceSubtypes: action.payload,
          isLoading: false,
          error: false,
        },
      };

    case GET_SERVICESUBTYPES_FAILURE:
      return {
        ...state,
        serviceSubtypesCatalog: {
          ...state.serviceSubtypesCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_PROVIDERS_REQUESTED:
      return {
        ...state,
        providersCatalog: {
          ...state.providersCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_PROVIDERS_SUCCESS:
      return {
        ...state,
        providersCatalog: {
          providers: action.payload,
          isLoading: false,
          error: false,
        },
      };

    case GET_PROVIDERS_FAILURE:
      return {
        ...state,
        providersCatalog: {
          ...state.providersCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_VERSIONS_REQUESTED:
      return {
        ...state,
        versionsCatalog: {
          ...state.versionsCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_VERSIONS_SUCCESS: {
      const sortedVersions = action.payload.slice().sort(versionsDescending);
      return {
        ...state,
        versionsCatalog: {
          versions: sortedVersions,
          isLoading: false,
          error: false,
        },
      };
    }

    case GET_VERSIONS_FAILURE:
      return {
        ...state,
        versionsCatalog: {
          ...state.versionsCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_REGIONS_REQUESTED:
      return {
        ...state,
        regionsCatalog: {
          ...state.regionsCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_REGIONS_SUCCESS:
      return {
        ...state,
        regionsCatalog: {
          regions: action.payload,
          isLoading: false,
          error: false,
        },
      };

    case GET_REGIONS_FAILURE:
      return {
        ...state,
        regionsCatalog: {
          ...state.regionsCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_PLANS_REQUESTED:
      return {
        ...state,
        plansCatalog: {
          ...state.plansCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_PLANS_FAILURE:
      return {
        ...state,
        plansCatalog: {
          ...state.plansCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_PLANS_SUCCESS: {
      const sortedPlans = action.payload.slice().sort(plansAscending);
      return {
        ...state,
        plansCatalog: {
          plans: sortedPlans,
          isLoading: false,
          error: false,
        },
      };
    }

    case GET_FLAVORS_REQUESTED:
      return {
        ...state,
        flavorsCatalog: {
          ...state.flavorsCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_FLAVORS_SUCCESS:
      return {
        ...state,
        flavorsCatalog: {
          flavors: action.payload,
          isLoading: false,
          error: false,
        },
      };

    case GET_FLAVORS_FAILURE:
      return {
        ...state,
        flavorsCatalog: {
          ...state.flavorsCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_ADDONS_REQUESTED:
      return {
        ...state,
        addonsCatalog: {
          ...state.addonsCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_ADDONS_SUCCESS:
      return {
        ...state,
        addonsCatalog: {
          addons: action.payload,
          isLoading: false,
          error: false,
        },
      };

    case GET_ADDONS_FAILURE:
      return {
        ...state,
        addonsCatalog: {
          ...state.addonsCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_CATALOG_CONFIG_REQUEST:
      return {
        ...state,
        configurationsCatalog: {
          ...state.configurationsCatalog,
          isLoading: true,
          error: false,
        },
      };

    case GET_CATALOG_CONFIG_FAILURE:
      return {
        ...state,
        configurationsCatalog: {
          ...state.configurationsCatalog,
          isLoading: false,
          error: action.payload,
        },
      };

    case GET_CATALOG_CONFIG_SUCCESS:
      return {
        ...state,
        configurationsCatalog: {
          isLoading: false,
          error: false,
          configurations: action.payload,
        },
      };

    default:
      return state;
  }
}
